import { Box, Avatar, Typography } from "@mui/material";
import React from "react";
import IChatbot from "../../../../interface/iChatbot";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import AvatarMia from "../../../../assets/images/mia-kreis.png";

const RenderBotIsTyping = (): React.JSX.Element => {
  const {
    chatbot,
    getAgentAvatar,
  }: {
    chatbot: IChatbot;
    getAgentAvatar: (message: IMessage) => string;
  } = React.useContext(AppContext);

  // there is no option in genesys to get the agent from the IsTyping event.
  // so we have to get the last agent message from the messages array
  const lastAgentMessage: IMessage | undefined = chatbot.messages
    .slice()
    .reverse()
    .find((msg) => msg.sender === "agent");

  // if there is no agent message, we have to use the default avatar
  const agentAvatar: string =
    lastAgentMessage && lastAgentMessage?.agent.name && lastAgentMessage
      ? getAgentAvatar(lastAgentMessage)
      : AvatarMia;
  const displayName = lastAgentMessage?.agent.name?.trim()
    ? lastAgentMessage.agent.name.trim()
    : "Agent";

  return (
    <Box
      role="status" // A11Y FIX
      aria-live="polite" // A11Y FIX
      aria-atomic="true" // A11Y FIX
      aria-label={`${displayName} schreibt gerade`} // A11Y FIX
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <Avatar alt="" src={agentAvatar} />{/* A11Y FIX */}
      <Typography variant="caption" color="initial">
        {displayName} schreibt ...
      </Typography>
    </Box>
  );
};

export default RenderBotIsTyping;
